import React, { HTMLProps } from "react";
import cn from "classnames";
import s from "../FilterPage.module.scss";

const Sort = ({ className, ...props }: HTMLProps<HTMLDivElement>) => (
  <div {...props} className={cn(className, s.sort)} />
);

export default Sort;
